import API from "util/API";

export const createAydenStore = async () => {
  return await API.post("/createStore");
};

export const getTerminals = async () => {
  const response = await API.get("/terminals");
  if (response && response.data && response.data.terminals) {
    return response.data.terminals;
  }
  return [];
};


export const getSweeps = async (restaurantId) => {
  const response = await API.post("/getSweeps", {restaurantId});
  if (response && response.data && response.data.sweeps) {
    return response.data.sweeps;
  }
  return [];
};

export const deleteSweep = async ({restaurantId, sweepId}) => {
  return await API.post("/deleteSweep", {restaurantId, sweepId});
};

export const transferPayout = async (transferAmount, transferDescription, restaurantId, transferTo, accountField, BSBField) => {
  return await API.post("/transferPayotus", {transferAmount, transferDescription, restaurantId, transferTo, accountField, BSBField});
};


export const setupPayoutSchedule = async (hour, minute, restaurantId) => {
  return await API.post("/setupPayoutSchedule", {hour, minute, restaurantId});
};

export const updateBankAccount = async (bsbCode, accountNumber) => {
  return await API.patch("/adyen/updateTransferInstrumentBankAccount", {bsbCode, accountNumber});
};

export const createPaymentType = async (paymentType) => {
  return await API.post("/createPaymentType", paymentType);
};

export const updatePaymentTypes = async (paymentTypes) => {
  return await API.post("/updatePaymentTypes", {paymentTypes});
};

export const getAllPaymentTypes = async () => {
  const response = await API.get("/paymentTypes");
  if (response && response.data && response.data.paymentTypes) {
    return response.data.paymentTypes.sort((a, b) => Number(a.sort) - Number(b.sort));
  }
  return [];
}

export const getGrantOffers = async () => {
  const response = await API.get("/grantOffers");
  if (response && response.data && response.data) {
    return response.data;
  }
  return [];
}

export const requestGrantOffer = async (grantOfferId) => {
  return await API.post("/grants", {grantOfferId});
}

export const getTerminalSettings = async (restaurantId, terminalId) => {
  return await API.get("/terminal/settings", {restaurantId, terminalId});
}

export const getStoreTerminalSettings = async (restaurantId) => {
  const response = await API.get(`/store/terminal/settings?restaurantId=${restaurantId}`);
  if (response && response.data && response.data.settings) {
    return response.data.settings;
  }
  return null;
}

export const getStoreSettings = async (restaurantId) => {
  const response = await API.get(`/store/settings?restaurantId=${restaurantId}`);
  if (response && response.data && response.data.settings) {
    return response.data.settings;
  }
  return null;
}

export const updateStoreSettings = async (storeSettings) => {
  return await API.post("/updateStoreSettings", {storeSettings});
}

// Before Adyen removes surcharges (midnight 1 Oct) the server only saves the rates; afterwards it
// replaces the merchant's Adyen split profile. Resolves to { applied, adyenPaymentSettings }.
// enableStandalone also switches the store's Adyen terminals to standalone mode once the rates apply.
export const updateStoreCommissionRates = async (restaurantId, commissionRates, { enableStandalone = false } = {}) => {
  const response = await API.post("/updateStoreCommissionRates", {
    restaurantId,
    commissionRates,
    ...(enableStandalone && { enableStandalone: true }),
  });
  return response.data;
}

// The restaurant's POS store as Adyen has it now: split profile (with rules) and terminal settings,
// with PINs and other secrets blanked by the server.
export const getStoreAdyenDetails = async (restaurantId) => {
  const response = await API.get(`/store/adyenDetails?restaurantId=${restaurantId}`);
  return response.data.details;
}

// Clears the POS store's surcharge settings (and any terminal overriding them). Resolves to
// { storeId, storeRemainingRules, terminals, removed } as Adyen reports it afterwards.
export const removeStoreSurcharges = async (restaurantId) => {
  const response = await API.post("/store/removeSurcharges", { restaurantId });
  return response.data.result;
}

// Applies the restaurant's saved commission rates to Adyen now. Resolves to { applied, adyenPaymentSettings }.
export const applyStoreCommissionRates = async (restaurantId) => {
  const response = await API.post("/store/applyCommissionRates", { restaurantId });
  return response.data;
}

export const updateBusinessLinesIndustryCode = async () => {
  return await API.patch("/adyen/updateBusinessLinesIndustryCode");
}